import { UIHeading2 } from '@cian/ui-kit';

import { type FC, type MouseEvent as ReactMouseEvent } from 'react';

import { Link } from '@/packages/shared-ui';

type TitleProps = {
  href: string;
  title: string;
  onClick(event: ReactMouseEvent<HTMLAnchorElement>): void;
};

export const Title: FC<TitleProps> = props => {
  const { href, onClick, title } = props;

  return (
    <Link behaviour="hover_primary_to_primary_hover" href={href} onClick={onClick}>
      <UIHeading2 as="h2" color="current_color">
        {title}
      </UIHeading2>
    </Link>
  );
};
